const List = () => import('./main.vue');

export default [
  {
    name: 'relatorio/posicao-beneficiario-data-empresa',
    path: '/relatorio/posicao-beneficiario-data-empresa',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Posição Beneficiário por Data e Empresa',
      icon: 'file-excel',
      can: 'rep283',
      on: 'report',
      client: 'bhtrans, pjf',
    },
  },
];
